import React from "react"
import "./Loading.scss"
import image from "./Loading.gif"

const Loading = () => {
  return <img className="Loading" alt="Loading..." src={image} />
}

export default Loading
